import { QObjGrouping } from "../CoreApp/QObjGrouping.js";

export function MatchToGroup(groupList, obj, combineDef) {
  var n = groupList.length;
  var v = obj.GetDataObj().GetFieldValue(combineDef);
  if (v == null) v = "";
  v = v.toString().trim().toLowerCase();

  for (var i = 0; i < n; i++) {
    var groupMember = groupList[i];
    if (groupMember.fMatchValue == v) {
      groupMember.fGroup.push(obj);
      return;
    }
  }

  var objGroup = new QObjGrouping();
  objGroup.fGroup = [obj];
  objGroup.fMatchValue = v;
  groupList.push(objGroup);
}
